/*@flow*/
/* eslint-disable no-loop-func*/
import assert from './assert';
import isFunction from './isFunction';
import isType from './isType';
import Any from './Any';

export default function match(...args: any[]): any | void {
  let type, guard, f;
  let count = 0;
  const x = args[0];

  for (let i = 1, len = args.length; i < len;) {
    type = args[i];
    guard = args[i + 1];
    f = args[i + 2];

    if (isFunction(f) && !isType(f)) {
      i += 3;
    } else {
      f = guard;
      guard = Any.is;
      i += 2;
    }

    if (process.env.NODE_ENV !== 'production') {
      count += 1;
      assert(isType(type), () => 'Invalid type in clause #' + count);
      assert(isFunction(guard), () => 'Invalid guard in clause #' + count);
      assert(isFunction(f), () => 'Invalid block in clause #' + count);
    }

    if (type.is(x) && guard(x)) {
      return f(x);
    }
  }
  assert.fail('Match error');
}
